import firebaseApp from '../../utils/firebase'
import TimeMe from 'timeme.js'

export default {
  triggerReactions({ state, dispatch }, data) {

    let reactions = data

    for (let i = 0; i < reactions.length; i++) {
      let reaction = reactions[i]
        dispatch('testReactionRules',reaction.if.rules)
          .then((tests)=>{

            let results = tests.filter(test=>test == true)
            if ((reaction.if.type == 'and' &&
              results.length == reaction.if.rules.length) ||
            (reaction.if.type == 'or' &&
            results.length))
              return Promise.resolve(reaction)

            return Promise.reject(reaction)

          })
          .then((item)=>{

            //console.log('doReactionActions', item.key)
            return dispatch('doReactionActions', item)

          })
          .then((item)=>{

            //console.log('success', item)
            return dispatch('markReactionDone', item)

          })
          .catch((e)=>{

            //console.log(e)

          })

    }

  },
  testReactionRules({ getters, dispatch }, rules) {


    let items = rules.map((item) => {
      if (item)
        return dispatch(item.type.replace(/\./g,''),item)
      else
        return function(){ return true }
    })

    return Promise.all(items)

  },
  doReactionActions({ getters, dispatch }, reaction) {

    let items = reaction.then.actions.map((item) => {
      if (item)
        return dispatch(item.type.replace(/\./g,''),item)
      else
        return function(){ return true }
    })

    return Promise.all(items)
      .then(()=>{
        return Promise.resolve(reaction)
      })
      .catch(()=>{
        return Promise.reject(reaction)
      })

  },
  markReactionDone({ getters, commit }, reaction) {

    const uid = getters.bindUID
    const sid = getters.bindSID
    const save = reaction.then.per

    if (save == 'page')
      commit('markReactionDone', reaction.key)

    if (save == 'visitor')
      firebaseApp.ref
        .child('visitors')
        .child(uid)
        .child('reactions_done')
        .child(reaction.key)
        .set(firebaseApp.TIMESTAMP)

    if (save == 'session')
      firebaseApp.ref
        .child('sessions')
        .child(sid)
        .child('reactions_done')
        .child(reaction.key)
        .set(firebaseApp.TIMESTAMP)

    return Promise.resolve(true)

  },
  // Rules to test
  rulespageurlMatch({}, rule) {
    const url = location && location.href ? location.href.toString().replace(/\//g, '\\/') : ''
    return Promise.resolve(rule.equate && eval(rule.equate.replace('{value}', rule.value.replace(/\//g, '\\/')) + '.test(url)'))
  },
  rulespageurlEquate({}, rule) {
    const url = location && location.href ? location.href.toString() : ''
    return Promise.resolve(rule.equate && eval("'" + url + "'" + rule.equate + "'" + rule.value + "'"))
  },
  rulessessionlength({ state }, rule) {
    const len = Math.floor(state.session.time_on)
    //console.log(state, len)
    return Promise.resolve(eval(len + rule.equate + rule.value))
  },
  rulessessionip({ state }, rule) {
    //console.log('test', rule)
    const ip = state.session.geoip.ip
    return Promise.resolve(ip && eval("'" + ip + "'" + rule.equate + "'" + rule.value + "'"))
  },
  ruleshistorypageCount({ getters }, rule) {
    //console.log('test', rule)
    const page_count = getters.getPageCount
    return Promise.resolve(eval(page_count + rule.equate + rule.value))
  },
  //Actions to do
  actionsmessagessendToVisitor({ dispatch, getters }, action) {

    let items = getters.getAPIMessages.filter((item)=>{
      return item.message == action.msg
    })

    if (!items.length)
    TimeMe.callAfterTimeElapsedInSeconds(parseInt(action.after),()=>{
      dispatch('jsPostMessage',{
        message: action.msg
      })
    })

    return Promise.resolve(true)
  },
  actionsmessagesgrabber({ dispatch, getters }, action) {

    let items = getters.getAPIMessages.filter((item)=>{
      return item.message == action.msg
    })

    if (!items.length)
    TimeMe.callAfterTimeElapsedInSeconds(parseInt(action.after),()=>{
      dispatch('jsPostMessage',{
        message: action.msg,
        grabber: action
      })
    })

    return Promise.resolve(true)
  }
}
